module.exports = __webpack_public_path__ + "img/lengqueta.2a8f312c.gif";